import React, { useEffect, useRef } from 'react';

// export default function ModalBox({ isOpen, onClose, title, body, iconType = 'success' }) {
//   const modalRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (modalRef.current && !modalRef.current.contains(event.target)) {
//         onClose();
//       }
//     };

//     if (isOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isOpen, onClose]);

//   if (!isOpen) return null;

//   return (
//     <div className="font-satoshi fixed inset-0 bg-black/50 flex items-center justify-center z-[1000]">
//       <div
//         ref={modalRef}
//         className="bg-white px-6 py-8 rounded-2xl shadow-2xl w-[90%] max-w-md relative"
//       >
//         {/* Close Button */}
//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl font-bold"
//         >
//           &times;
//         </button>

//         {/* Icon */}
//         <div className="text-center text-5xl mb-4">
//           {iconType === 'success' ? '✅' : iconType === 'error' ? '❌' : 'ℹ'}
//         </div>

//         {/* Title */}
//         <h2 className="text-2xl font-semibold text-center text-gray-800 mb-2">
//           {title}
//         </h2>

//         {/* Body */}
//         <p className="text-lg text-gray-700 text-center mb-6">
//           {body}
//         </p>

//         {/* Action */}
//         <div className="flex justify-center">
//           <button
//             onClick={onClose}
//             className="bg-[#21A6E9] text-white px-6 py-2 rounded-full text-sm hover:bg-[#1C91CA] transition duration-200"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }


export default function ModalBox({ isOpen, onClose, title, body, iconType = 'success', onAction, actionLabel = 'Close', }) {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="font-satoshi fixed inset-0 bg-black/50 flex items-center justify-center z-[1000]">
      <div
        ref={modalRef}
        className="bg-white px-6 py-8 rounded-2xl shadow-2xl w-[90%] max-w-md relative"
      >
        {/* Close Icon */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-xl font-bold"
        >
          &times;
        </button>

        {/* Icon */}
        <div className="text-center text-5xl mb-4">
          {iconType === 'success' ? '✅' : iconType === 'error' ? '❌' : 'ℹ'}
        </div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-center text-gray-800 mb-2">
          {title}
        </h2>

        {/* Body */}
        <p className="text-lg text-gray-700 text-center mb-6">
          {body}
        </p>

        {/* Action */}
        <div className="flex justify-center">
          <button
            onClick={onAction || onClose} // 👈 use onAction if available
            className="bg-[#21A6E9] text-white px-6 py-2 rounded-full text-sm hover:bg-[#1C91CA] transition duration-200"
          >
             {actionLabel} 
          </button>
        </div>
      </div>
    </div>
  );
}
